import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {Provincia, ProvinciaRequestPaginated} from "./provincia-dialog.model";
import { CommunicationConstants } from 'src/app/core/constants/communication';
import { environment } from 'src/environments/environment';
import { IResult } from 'src/app/core/interfaces/result';

const API_MAIN = environment.segurity + environment.host + environment.version + environment.typeService;

@Injectable()
export class ProvinciaDialogService {

  private URL : string = API_MAIN + "province-api/get-all";

	constructor(
    private _http: HttpClient,
  ){}

	getPaginated(request : ProvinciaRequestPaginated) : Observable<any>{

		return this._http
      .post<IResult<Provincia>>(this.URL, request)
      .pipe(
        map((res: IResult<Provincia>) => {
          const [codigosCom, mensajesCom] = CommunicationConstants;
          if (res === null){
              throw new Error(`${codigosCom.ERRORSRV}||${mensajesCom.MSGDATAVACIOSRV}`);
          }
          if(!res.Succeeded){
              throw new Error(`${res.Succeeded}||${res.Message}`);
          }
          return res.Data;
        })
      );
	}


}
